import type { Phrases } from '../../common/Phrases.d';

import React, { useEffect, useRef } from 'react';
import { useFormContext } from '/react4xp/components/react-hook-form/FormContext';
import { Legend } from '/react4xp/components/Element';
import { Fieldset } from '../../../../components/react-hook-form/Fieldset';
import { ReactionsButtonGroup } from './ReactionsButtonGroup';
import { ReactionsOtherTextField } from './ReactionsOtherTextField';
import { SERVICES_FIELD_NAME } from '../constants';


const REACTIONS_LEGEND_ID = 'reactionsLegend';

export const ReactionsFieldset = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const legend = phrases['notificationForm.services.reactionsField.label'];
	const { setScrollRef } = useFormContext();

	const scrollRef = useRef();

	useEffect(() => {
		if (scrollRef.current) {
			setScrollRef({
				field: SERVICES_FIELD_NAME.REACTIONS_OTHER,
				el: scrollRef.current,
			});
		}
	}, [scrollRef.current]);

	return (
		<Fieldset
			borderless
			legend={legend}
			legendId={REACTIONS_LEGEND_ID}
			legendRef={scrollRef}
		>
			<ReactionsButtonGroup aria-labelledby={REACTIONS_LEGEND_ID} phrases={phrases}/>
			<ReactionsOtherTextField phrases={phrases}/>
		</Fieldset>
	);
};
